import type { AppTheme } from "../../../app/providers/ThemeProvider";

export type Md3ButtonVariant = "filled" | "tonal" | "outlined" | "text";
export type Md3ButtonColor =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning";
export type Md3ButtonSize = "small" | "medium" | "large";

export type Md3ButtonPalette = {
  background: string;
  label: string;
  border: string;
  stateLayer: string;
};

export function resolveMd3ButtonPalette(
  theme: AppTheme,
  variant: Md3ButtonVariant,
  color: Md3ButtonColor
): Md3ButtonPalette {
  const filledMap = {
    primary: theme.colors.primary,
    secondary: theme.colors.secondary,
    success: theme.colors.success,
    danger: theme.colors.danger,
    warning: theme.colors.warning,
  } as const;

  const tonalMap = {
    primary: theme.colors.primaryAlpha10,
    secondary: "rgba(236, 72, 153, 0.12)",
    success: "rgba(16, 185, 129, 0.12)",
    danger: "rgba(239, 68, 68, 0.12)",
    warning: "rgba(245, 158, 11, 0.12)",
  } as const;

  const accent = filledMap[color];

  if (variant === "filled") {
    return {
      background: accent,
      label: theme.colors.white,
      border: accent,
      stateLayer: theme.colors.white,
    };
  }

  if (variant === "tonal") {
    return {
      background: tonalMap[color],
      label: accent,
      border: "transparent",
      stateLayer: accent,
    };
  }

  if (variant === "outlined") {
    return {
      background: "transparent",
      label: accent,
      border: accent,
      stateLayer: accent,
    };
  }

  return {
    background: "transparent",
    label: accent,
    border: "transparent",
    stateLayer: accent,
  };
}

export const sizeConfig = {
  small: { minHeight: 40, fontSize: 14, paddingX: 16 },
  medium: { minHeight: 48, fontSize: 19, paddingX: 24 },
  large: { minHeight: 56, fontSize: 19, paddingX: 28 },
} as const;
